export default {
  choose_preferred_wallet: "Escolha sua carteira preferida",
  connect_mobile_wallet: "Conectar-se à carteira móvel",
  scan_qrcode_with_wallet: "Ler o código QR com uma carteira compatível com WalletConnect",
  return_to_mobile_options: "Voltar às opções de carteira móvel",
  view_qrcode_option: "Ver o código QR",
  connect: "Conectar",
};
